export const ERROR_WRONG_PASSWORD = 'wrongPassword'
export const EMAIL_NOT_FOUND = 'emailNotFound'
export const ERROR_UNKNOWN = 'unknown'



// WEBPACK FOOTER //
// ./src/services/signin/constants.js